import { submitForm } from 'actions';
import { IAM } from 'constants';

export default (formName, resourcePath, userGuid, body, callerOptions = {}) =>
  submitForm(
    formName,
    `${IAM.baseUrl}${resourcePath}`,
    userGuid,
    body,
    callerOptions,
  );
